(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dsm-header-wishlist"] && !Shopify.designMode) return;
  try {
    const dsmHeaderWishlistKey = 'dsm-wishlist-handles';

  const readDsmHeaderWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(dsmHeaderWishlistKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_error) {
      return [];
    }
  };

  const updateDsmHeaderWishlistCount = () => {
    const count = readDsmHeaderWishlist().length;
    document.querySelectorAll('[data-dsm-header-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  };

  const makeDsmWishlistProduct = (product) => {
    const link = document.createElement('a');
    link.className = 'dsm-header-wishlist__product';
    link.href = product.url;

    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title;
      image.loading = 'lazy';
      link.append(image);
    }

    const content = document.createElement('div');
    const title = document.createElement('p');
    title.className = 'dsm-header-wishlist__product-title';
    title.textContent = product.title;

    const price = document.createElement('p');
    price.className = 'dsm-header-wishlist__product-price';
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(product.price / 100);

    content.append(title, price);
    link.append(content);
    return link;
  };

  const openDsmHeaderWishlist = async (button) => {
    const actions = button.closest('header-actions');
    const dialog = actions?.querySelector('[data-dsm-header-wishlist-dialog]');
    const list = dialog?.querySelector('[data-dsm-header-wishlist-list]');
    if (!dialog || !list) return;

    const handles = readDsmHeaderWishlist();
    list.replaceChildren();

    if (handles.length === 0) {
      const empty = document.createElement('p');
      empty.textContent = dialog.dataset.emptyText;
      list.append(empty);
      dialog.showModal();
      return;
    }

    const loading = document.createElement('p');
    loading.textContent = dialog.dataset.loadingText;
    list.append(loading);
    dialog.showModal();

    try {
      const products = await Promise.all(
        handles.map((handle) =>
          fetch(`/products/${encodeURIComponent(handle)}.js`).then((response) => {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          })
        )
      );
      list.replaceChildren(...products.map(makeDsmWishlistProduct));
    } catch (_error) {
      const error = document.createElement('p');
      error.textContent = dialog.dataset.errorText;
      list.replaceChildren(error);
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-dsm-header-wishlist-open]');
    if (openButton) {
      openDsmHeaderWishlist(openButton);
      return;
    }

    const closeButton = event.target.closest('[data-dsm-header-wishlist-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.closest('[data-dsm-wishlist-handle]')) {
      setTimeout(updateDsmHeaderWishlistCount, 0);
    }
  });

  window.addEventListener('storage', updateDsmHeaderWishlistCount);
  document.addEventListener('DOMContentLoaded', updateDsmHeaderWishlistCount);
  document.addEventListener('shopify:section:load', updateDsmHeaderWishlistCount);
  updateDsmHeaderWishlistCount();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dsm-product-actions"] && !Shopify.designMode) return;
  try {
    const dsmWishlistKey = 'dsm-wishlist-handles';

  const readDsmWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(dsmWishlistKey) || '[]');
    } catch (_error) {
      return [];
    }
  };

  const updateDsmWishlistButtons = () => {
    const savedHandles = readDsmWishlist();
    document.querySelectorAll('[data-dsm-wishlist-handle]').forEach((button) => {
      button.setAttribute('aria-pressed', savedHandles.includes(button.dataset.dsmWishlistHandle) ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dsm-wishlist-handle]');
    if (!button) return;

    const handle = button.dataset.dsmWishlistHandle;
    const savedHandles = readDsmWishlist();
    const updatedHandles = savedHandles.includes(handle)
      ? savedHandles.filter((savedHandle) => savedHandle !== handle)
      : [...savedHandles, handle];

    try {
      localStorage.setItem(dsmWishlistKey, JSON.stringify(updatedHandles));
    } catch (_error) {
      return;
    }

    updateDsmWishlistButtons();
  });

  document.addEventListener('DOMContentLoaded', updateDsmWishlistButtons);
  document.addEventListener('shopify:section:load', updateDsmWishlistButtons);
  updateDsmWishlistButtons();
  } catch(e) { console.error(e); }
})();

})();
